import TspApiService from "../../api/tspApiService";

const EXTENSION = { csv: "csv", xlsx: "xlsx", pdf: "pdf" };

// Fetches the export exactly like the on-screen report (same filters, same
// authorization) and saves it — the server never sends more than the JSON
// response already showed (see reports/export.js on the backend).
export default async function downloadReport(reportKey, format, filters) {
  const blob = await TspApiService.reports.download(reportKey, format, filters);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${reportKey}-report.${EXTENSION[format]}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
